<template>
  <router-link
    v-if="isInternalPage"
    :to="`/${slug}`"
    class="flex items-center justify-between border-menu pl-5 text-white no-underline menu-option"
  >
    <slot></slot>
  </router-link>
  <a
    v-else-if="isHandler"
    href=""
    @click.prevent="openMenuHandler(slug)"
    class="flex items-center justify-between border-menu pl-5 text-white no-underline menu-option"
  >
    <slot></slot>
  </a>
  <router-link v-else-if="slug.startsWith('/')" :to="slug" class="flex items-center justify-between border-menu pl-5 text-white no-underline menu-option">
    <slot></slot>
  </router-link>
  <a v-else :href="slug" target="_blank" class="flex items-center justify-between border-menu pl-5 text-white no-underline menu-option">
    <slot></slot>
  </a>
</template>

<script>
import api from '@/http'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MenuOption',

  computed: {
    ...mapState(['digitalHubLink', 'selectedOffice']),
    isHandler () {
      return this.type === 'FEATURE'
    },

    isInternalPage () {
      return this.type === 'PAGE' || this.slug === 'marketing-packs'
    }
  },

  methods: {
    ...mapActions(['authInsight', 'displayToastNotification']),

    /**
     * Run the appropriate handler function for the given feature.
     *
     * @param {string} feature Feature to initiate.
     */
    openMenuHandler (feature) {
      const handlers = {
        digitalHub: this.handlerDigitalHub,
        insight: this.authInsight,
        knowledgeHub: () => {
          this.handlerKnowledgeHub('/')
        },
        partnerPages: () => this.$router.push('/our-partners'),
        pom: this.handlerPom,
        propertyCms: () => this.$router.push('/property-management'),
        propertyFeeds: () => this.$router.push('/property-feeds'),
        webinars: () => {
          this.handlerKnowledgeHub('/webinar')
        },
        websiteCms: this.handlerWebsiteCms,
        annualReview: () => this.$router.push('/annual-review'),
        qrGenerator: () => this.$router.push('/qr-generator')
      }

      if (handlers[feature]) {
        handlers[feature]()
      }
    },

    /**
     * Displays a notification to the user that authentication has failed.
     *
     * @param {string} message Additional information.
     */
    displayAuthenticationWarning (message) {
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-bell',
        title: 'Authentication Failed',
        info: message
      })
    },

    /**
     * Opens a new tab to the specified location.
     *
     * @param {string} uri URI to navigate to.
     */
    openNewTab (uri) {
      let newTab = window.open()
      newTab.location.href = uri
    },

    /**
     * Handler for the `digitalHub` feature.
     */
    handlerDigitalHub () {
      this.openNewTab(this.digitalHubLink)
    },

    /**
     * Handler for the `knowledgeHub` feature.
     *
     * @param {string} redirectTo URI for redirection.
     */
    handlerKnowledgeHub (redirectTo) {
      api
        .post('knowledge', {
          redirectTo: redirectTo
        })
        .then(response => {
          this.openNewTab(response.data.url)
        })
        .catch(({ response }) => {
          this.displayAuthenticationWarning(response.data.message)
        })
    },

    /**
     * Handler for the `pom` feature.
     */
    handlerPom () {
      api
        .post('pom', { office_id: this.selectedOffice.id })
        .then(response => {
          this.openNewTab(response.data.url)
        })
        .catch(({ response }) => {
          this.displayAuthenticationWarning(response.data.message)
        })
    },

    /**
     * Handler for the `websiteCms` feature.
     */
    handlerWebsiteCms () {
      api
        .post('website-cms', { 'office_id': this.selectedOffice.id })
        .then(response => {
          let newTab = window.open()
          newTab.location.href = response.data.url
        })
    }
  },

  props: {
    slug: {
      type: String,
      required: true
    },

    type: {
      type: String,
      required: true
    }
  }
}
</script>
